import '@ui5/webcomponents/dist/RadioButton.js';
import { ValueState } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `RadioButton` component enables users to select a single option from a set of options. When a `RadioButton` is selected by the user, the `onChange` event is fired. When a `RadioButton` that is within a group is selected, the one that was previously selected gets automatically deselected. You can group radio buttons by using the `name` property.
 * **Note:** If `RadioButton` is not part of a group, it can be selected once, but can not be deselected back.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/RadioButton" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const RadioButton = withWebComponent('ui5-radio-button', ['accessibleNameRef', 'name', 'text', 'value', 'valueState', 'wrappingType'], ['checked', 'disabled', 'readonly'], [], ['change']);
RadioButton.displayName = 'RadioButton';
RadioButton.defaultProps = {
    valueState: ValueState.None
};
export { RadioButton };
